import React, { PureComponent } from 'react'
import { iconMapper } from '../../utils/utilities'
import {Radio, RadioGroup} from 'react-radio-group'

class Sports extends PureComponent {

  handleChange(key, value) {
    this.props.onSelected()
    this.props.setFiltersData(value, 'sportFilter')
  }

  render() {
    return (
      <div className="filter-sports">
          <RadioGroup className="filter-sports-wrapper" selectedValue={this.props.d} onChange={this.handleChange.bind(this, this.value)}>
            <label><Radio value="Alle" /><img src={iconMapper('Multisport')} alt="alle-icon"/><p>Alle</p></label>
            <label><Radio id="Laufen" value="Laufen" /><img src={iconMapper('Laufen')} alt="laufen-icon"/><p>Laufen</p></label>
            <label><Radio value="Biken" /><img src={iconMapper('Biken')} alt="biken-icon"/><p>Biken</p></label>
            <label><Radio value="Schwimmen" /><img src={iconMapper('Schwimmen')} alt="schwimmen-icon"/><p>Schwimmen</p></label>
            <label><Radio value="Inlineskaten" /><img src={iconMapper('Inlineskaten')} alt="inlineskaten-icon"/><p>Inlineskaten</p></label>
            <label><Radio value="Skilaufen" /><img src={iconMapper('Skilaufen')} alt="skilaufen-icon"/><p>Skilaufen</p></label>
            <label><Radio value="Rollerskifahren" /><img src={iconMapper('Rollerskifahren')} alt="rollerskifahren-icon"/><p>Rollerskifahren</p></label>
            <label><Radio value="OCR" /><img src={iconMapper('OCR')} alt="ocr-icon"/><p>Obstacle Course Racing</p></label>
            <label><Radio value="Multisport" /><img src={iconMapper('Multisport')} alt="multipsort-icon"/><p>Multisport</p></label>
        </RadioGroup>
      </div>
    )
  }
}

export default Sports


// WEBPACK FOOTER //
// ./src/components/parts/Sports.js